import React, {useEffect, useState} from 'react'
import ClosedServiceReactTable from './ClosedServiceReactTable'
import Modal from "react-modal";
import ModalContent from '../../common/Modal/ModalContent';
import close_modal from '../../assets/ic_close_wh.svg'
import api from '../../utils/api';
import { toast } from 'react-toastify';
import Spinner from '../../common/Spinner/Spinner';
import { Button } from '../../common/Button/Button';

const ClosedServiceInterface = () => {
    const [openModal, setOpenModal] = useState(false)
	const [data, setData] = useState()
	const [isLoading, setIsLoading] = useState(false);
    const [resourceId, setResourceId] = useState("")
	const [resouceInstanceId, setResourceInstanceId] = useState("")
	const [pages, setPages] = useState(0);
	const [count, setCount] = useState(0);
    const [pageSize, setPageSize] = useState(10);
    const [currentPage, setcurrentPage] = useState(0);
    const [tableInstance, setTableInstance] = useState(null);
	const [pageSizeOptions, setpageSizeOptions] = useState([
        {
            value: "10",
            label: "10 Rows",
        },
        {
            value: "20",
            label: "20 Rows",
        },
        {
            value: "30",
            label: "30 Rows",
        },
        {
            value: "50",
            label: "50 Rows",
        },
        {
            value: "75",
            label: "75 Rows",
        },
        {
            value: "100",
            label: "100 Rows",
        },
    ]);
    const [selectedPageSizeOption, setSelectedPageSizeOption] = useState({
        value: "10",
        label: "10",
    });

	useEffect(() => {
		getGridData(tableInstance, true)
	}, [selectedPageSizeOption])

      const openModalisTrue = () => {
        setOpenModal(true)
      }

      const openModalisFalse = () => {
        setOpenModal(false)
      }

      const onOpenBtnClick = (ele) => {
        openModalisTrue()
        setResourceId(ele)
      }

      const onConfirmClick = () => {
        try{
			setIsLoading(true)
			let payload = {
				nParentId: resourceId
			}
			const { tempOpenServices } = api.openService(payload)
			.then(({data}) => {
				if(data.Result === "Success"){
					setIsLoading(false)
				openModalisFalse()
				getGridData(tableInstance,true)
				toast("Service Reopened", {
					autoClose: 5000,
					type: toast.TYPE.SUCCESS,
				});
				}
			})
		} catch(error) {

		}
      }

	  const getGridData = async(instance, flag= false) => {
		if (!instance) return;
        if (!tableInstance) setTableInstance(instance);

		try{
			const { page } = instance.state ?? { page: 0 };
            let icurrentPage = page;
            if (!flag && isNaN(icurrentPage)) return;
            const pageSize = selectedPageSizeOption.value;

            if (flag || isNaN(icurrentPage)) {
                icurrentPage = 0;
            }

			let filterParameters = {
                page: icurrentPage + 1,
                page_size: pageSize,
                // pagination: true,
                // SP_email: 'archana.sapre@mailinator.com'
            };

			if(resouceInstanceId){
				filterParameters.nResourceInstanceId = resouceInstanceId
			}

			setIsLoading(true);

			const {tempClosedServices} = api.getCloseServicesData(filterParameters)
			.then(({data}) => {
				setIsLoading(false);
                if (data) {
                    const { results, count } = data;
                    setcurrentPage(icurrentPage);
                    const totalPages = (count - 1) / pageSize + 1;
                    setCount(count);
                    setPages(Math.floor(totalPages));
                    setPageSize(pageSize);
                    setData(results);
                }
				else {
                    toast("Something went wrong. Please contact Deasra Representative.", {
                        autoClose: 5000,
                        type: toast.TYPE.ERROR,
                    });
                }
			})

		} catch(error) {
			setIsLoading(false);
            console.log(error)
            toast("Internal Server Error", {
                autoClose: 5000,
                type: toast.TYPE.ERROR,
            });
		}
	  }

	  const fetchServiceRequests = (instance, flag) => {
        getGridData(instance, flag);
    };

	const onSearchClick = () => {
		getGridData(tableInstance, true)	
	}

	const onReopenPress = () => {
		
	}

  return (
	<div className={`${isLoading && "set-opacity"}`}>
            {isLoading && <Spinner className="center-screen" />}
    <div>
         <Modal isOpen={openModal} style={{ zIndex: 1 }}>
				<ModalContent className="confirmation-modal-small">
					<div className="modal-header" style={{
						backgroundColor: '#76287C',
						color: '#fff'
					}}>
						<span className="modal-title">Confirm</span>
						<img
							alt="close"
							id="Close"
							src={close_modal}
							className="close modal-close"
							onClick={openModalisFalse}
						/>
					</div>

					<div className="modal-body">
						Are you sure you want to perform this action?
						<div className="row">
							<div className="col-12 d-flex align-items-center" style={{
								justifyContent: 'flex-end'
							}}>
								<button
									type="button"
									className="my-services-model-submit-btn conv-mr25"
									onClick={onConfirmClick}
                                    >
									Yes
								</button>
								<button
									type="button"
									className="my-services-model-cancel-btn conv-mr25"
									onClick={() => {
										openModalisFalse()
									}}>
									No
								</button>
							</div>

						</div>
					</div>
				</ModalContent>
			</Modal>

			<div className="row d-flex align-items-center" style={{
                    height: "75px",
                    marginBottom: '25px',
                    boxShadow: "0 5px 10px -2px rgba(0, 0, 0, 0.5)"
                }} >
					<div className="col-2 spled-container">
					<div className="width-100">
                                        <input
                                            className='form-control'
                                            onKeyDown={(e) => {
												const isBackspace = e.keyCode === 8;
    const isNumericKey = e.keyCode >= 48 && e.keyCode <= 57;

    // If the pressed key is not a backspace or a numeric key, prevent default action
    if (!isBackspace && !isNumericKey) {
        e.preventDefault();
    }
											}}
                                            type="text"
                                            placeholder="Resource Id"
                                            value={resouceInstanceId}
                                            onChange={(e) => setResourceInstanceId(e.target.value)}
                                        />
                                    </div>
						</div>
						<div className='col-8'>
						<Button className="p-2" style={{width: "100px"}} 
						onClick={onSearchClick}
						>Search</Button>
						</div>
						

				</div>


      <ClosedServiceReactTable
			  onOpenBtnClick={onOpenBtnClick}
			  data={data}
			  onFetchServiceRequests={fetchServiceRequests}
			  pages={pages}
			  pageSize={pageSize}
			  page={currentPage}
			  pageSizeOptions={pageSizeOptions}
			  selectedPageSizeOption={selectedPageSizeOption}
			  onPageSizeOptionChange={(option) => {
				  setSelectedPageSizeOption(option);
			  }}
	   />
    </div>
	</div>
  )
}

export default ClosedServiceInterface
